import Navbar from './Navbar/Navbar';
import Footer from './Footer/footer';
import Home from './Home/home';
import AboutMe from './AboutMe/aboutme';
import Experiences from './Experience/Experiences';
import Project from './Project/project';
import Contact from './Contact/contact';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css'
function App() {
  return (
    <div className=' overflow-x-hidden'>
      <Router>
        <Navbar />
        <hr />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/aboutme' element={<AboutMe />} />
          <Route path='/experiences' element={<Experiences />} />
          <Route path='/projects' element={<Project />} />
          <Route path='/contactme' element={<Contact />} />
        </Routes>
        
        <Footer />
      </Router>
    </div>
  );
}

export default App;
